import { render, staticRenderFns } from "./CardCause.vue?vue&type=template&id=6ee78077&scoped=true&"
import script from "./CardCause.vue?vue&type=script&lang=js&"
export * from "./CardCause.vue?vue&type=script&lang=js&"
import style0 from "./CardCause.vue?vue&type=style&index=0&id=6ee78077&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee78077",
  null
  
)

export default component.exports